const getURL = location.pathname.indexOf("default.aspx");
const baseUrl = SITEBASEURL + "p/tickets";

if (getURL >= 0 || location.pathname === "/") {
  window.location = baseUrl;
}

function escapeHtml(text) {
  return String(text || "")
    .replaceAll(/&/g, "&amp;")
    .replaceAll(/</g, "&lt;")
    .replaceAll(/>/g, "&gt;")
    .replaceAll(/"/g, "&quot;")
    .replaceAll(/'/g, "&#39;");
}

function cropText(text, maxLength) {
  return text.length > maxLength ? text.substring(0, maxLength) : text;
}

function modifyFeatureLineup() {
  function createContentWrapper(titleText, croppedTitle, descriptionText) {
    const safeTitleText = escapeHtml(titleText);
    const safeCroppedTitle = escapeHtml(croppedTitle);
    const safeDescriptionText = escapeHtml(descriptionText);

    return `
      <span class="featureLineup-content">
        <h4 title="${safeTitleText}" aria-label="${safeTitleText}">${safeCroppedTitle}</h4>
        ${safeDescriptionText ? `<span class="feature-description">${safeDescriptionText}</span>` : ""}
      </span>
    `;
  }

  $(".featureLineupContainer").each((i, element) => {
    const $element = $(element);
    const $imageContainer = $element.find(".featureLineupImage");
    const $textContainer = $element.find(".featureLineup-text").first();
    const $title = $element.find(".featureLineup-title");
    const $moreBtn = $element.find(".featureLineup-more");
    const descriptionFromClass = $textContainer
      .find(".feature-description")
      .first()
      .text()
      .trim();
    const fallbackDescription = $textContainer
      .clone()
      .find(".featureLineup-title, .featureLineup-more")
      .remove()
      .end()
      .text()
      .trim();
    const descriptionText = descriptionFromClass || fallbackDescription;
    $element.find(".featureLineup-text").remove();

    const titleText = $title.text().trim();
    const croppedTitle = cropText(titleText, 35);

    const contentWrapper = createContentWrapper(
      titleText,
      croppedTitle,
      descriptionText,
    );
    const wrapperAux = `
    <span class="featureLineup-text">
      ${contentWrapper}
    </span>
    `;

    $title.remove();
    $moreBtn.find(".button").addClass("button-small");

    $imageContainer.append(wrapperAux);
    $imageContainer.find(".featureLineup-content").append($moreBtn);
  });
}

$(document).ready(function () {
  $(".generalmessage").prependTo("header");
  $(".header-logo").attr("href", "" + baseUrl);
  modifyFeatureLineup();
});
